import React from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import VedioIcon from 'assets/images/Dashboard/Video_Call_list.svg';
import DoctorIcon from 'assets/images/Dashboard/doctor-list.svg';
import Download from 'assets/images/Dashboard/dowload.svg';

const PatientDetailAppointment = () => {
  const patientDetailValue = useSelector(
    (state) => state?.patientDetailReducer?.users?.data
  );

  const loading = useSelector((state) => state?.patientDetailReducer?.loading);

  return (
    <div>
      {/* <div className="fs-16 pt-24 pb-12 fc-292D32 family_outfit_medium_500 lh-16">
        Appointment History
      </div> */}
      {loading ? (
        <Loader marginTop={'20vh'} />
      ) : patientDetailValue?.appointment_history &&
        patientDetailValue?.appointment_history.length > 0 ? (
        <>
          <Row className="listCustomHeader m-0 p-0 flex items-center">
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Provider’s & ID" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Booking ID" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Modality" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Date & Time" />
              </p>
            </Col>
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Actions" />
              </p>
            </Col>
          </Row>
          {patientDetailValue?.appointment_history.map((item, index) => {
            return (
              <>
                <Row className="bc-FFFFFF m-0 p-0">
                  <Row className="m-0 p-0 flex items-center listAppointment">
                    <Col lg={3} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center p-0"
                      >
                        <div className="list-image">
                          <Image
                            src={item?.provider_details?.profile_image}
                            alt=""
                            className="list-image"
                          />
                        </div>
                        <div>
                          <p className="p-0 m-0 fs-12 family_outfit_semiBold_600 lh-1512 fc-202224">
                            {item?.provider_details?.provider_name}
                          </p>
                          <p className="pt-04 m-0 fs-12 family_outfit_regular_400 lh-1512 fc-202224">
                            {item?.provider_details?.provider_id}
                          </p>
                        </div>
                      </Stack>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                        {item?.booking_id}
                      </div>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <div className="flex items-center">
                        <Image
                          src={
                            item?.consultation_type === 'Digital Consultation'
                              ? VedioIcon
                              : DoctorIcon
                          }
                          alt="icon"
                        />
                      </div>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                        {moment(item?.appointment_date_time).format(
                          'DD MMM YYYY, hh:mmA'
                        )}
                      </div>
                    </Col>
                    <Col lg={3} md={6} sm={12}>
                      <div className="flex" key={index}>
                        <a
                          href={item?.diagnosis_report || '#'}
                          download={
                            item?.diagnosis_report
                              ? item?.diagnosis_report.split('/').pop()
                              : 'license'
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="fs-16 lh-201 fc-5B88E9 family_outfit_regular_400 cursor-pointer underline underline-offset-4 break-all ..."
                        >
                          {item?.diagnosis_report &&
                            item?.diagnosis_report.split('/').pop()}
                        </a>
                        <div className="pl-8">
                          <Image src={Download} alt="icon" />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Row>
              </>
            );
          })}
        </>
      ) : (
        <div className="flex justify-center pt-120">
          <div>
            <Image src={EmptyScreen} alt="icon" />
            <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
              Nothing here yet
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientDetailAppointment;
